import {
    SET_ERROR_NOTIFICATION,
    SET_SUCCESS_NOTIFICATION,
    SET_WARNING_NOTIFICATION,
    SET_INFO_NOTIFICATION,
    DISMISS_ERROR_NOTIFICATION,
    DISMISS_SUCCESS_NOTIFICATION,
    DISMISS_WARNING_NOTIFICATION,
    DISMISS_INFO_NOTIFICATION,
    DISMISS_ALL_NOTIFICATIONS
} from '../actionTypes';

const dismissNotificationTypes = {
    error: DISMISS_ERROR_NOTIFICATION,
    success: DISMISS_SUCCESS_NOTIFICATION,
    warning: DISMISS_WARNING_NOTIFICATION,
    info: DISMISS_INFO_NOTIFICATION,
    all: DISMISS_ALL_NOTIFICATIONS
};

const setNotificationTypes = {
    error: SET_ERROR_NOTIFICATION,
    success: SET_SUCCESS_NOTIFICATION,
    warning: SET_WARNING_NOTIFICATION,
    info: SET_INFO_NOTIFICATION
};

export function dismissNotification(notificationType) {
    return (dispatch) => {
        dispatch({
            type: dismissNotificationTypes[notificationType]
        });
    }
}

export function setNotification(notificationType, notificationMessage) {
    return (dispatch) => {
        dispatch({
            // ensures that only one notification type is active at a time
            type: dismissNotificationTypes.all
        });
        dispatch({
            type: setNotificationTypes[notificationType],
            payload: notificationMessage
        });
    }
}
